<button
  click-stop-propagation
  [class]="'adap-btn-' + props.style"
  (click)="props.action(data)"
  [disabled]="props.disabled"
>
  {{ props.text }}
</button>
